var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcListening(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 34.396,
    height: 33.563,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_listening",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(336.635 223.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224-2",
    "data-name": "Group 224",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21946",
    "data-name": "Path 21946",
    d: "M11.245,4.912h-.851A2.728,2.728,0,0,0,7.676,7.633v9.82a2.725,2.725,0,0,0,2.718,2.721h.851a2.726,2.726,0,0,0,2.721-2.721V7.633a2.729,2.729,0,0,0-2.721-2.721",
    transform: "translate(19.557 12.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 6.294,
    height: 15.263,
    rx: 0.767,
    transform: "translate(0.869 17.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21947",
    "data-name": "Path 21947",
    d: "M7.676,15.5a2.728,2.728,0,0,0,2.718,2.721h.851A2.729,2.729,0,0,0,13.97,15.5V5.68Z",
    transform: "translate(19.557 14.473)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21948",
    "data-name": "Path 21948",
    d: "M.245,15.5A2.729,2.729,0,0,0,2.97,18.222h.844A2.734,2.734,0,0,0,6.539,15.5V5.68Z",
    transform: "translate(0.624 14.473)",
    fill: "#d84f45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21949",
    "data-name": "Path 21949",
    d: "M11.869,21.668h-.851a3.592,3.592,0,0,1-3.587-3.59V8.257a3.592,3.592,0,0,1,3.587-3.59h.851a3.6,3.6,0,0,1,3.594,3.59v9.82a3.6,3.6,0,0,1-3.594,3.59M11.018,6.405A1.853,1.853,0,0,0,9.169,8.257v9.82a1.853,1.853,0,0,0,1.848,1.852h.851a1.854,1.854,0,0,0,1.856-1.852V8.257a1.854,1.854,0,0,0-1.856-1.852Z",
    transform: "translate(18.933 11.892)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21950",
    "data-name": "Path 21950",
    d: "M4.438,21.668H3.594A3.6,3.6,0,0,1,0,18.078V8.257a3.6,3.6,0,0,1,3.594-3.59h.844a3.6,3.6,0,0,1,3.594,3.59v9.82a3.6,3.6,0,0,1-3.594,3.59M3.594,6.405A1.856,1.856,0,0,0,1.738,8.257v9.82A1.856,1.856,0,0,0,3.594,19.93h.844a1.854,1.854,0,0,0,1.856-1.852V8.257A1.854,1.854,0,0,0,4.438,6.405Z",
    transform: "translate(0 11.892)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21951",
    "data-name": "Path 21951",
    d: "M34.4,30.145H32.658V16.5c0-8.142-6.936-14.766-15.458-14.766S1.738,8.361,1.738,16.5V30.145H0V16.5C0,7.4,7.717,0,17.2,0S34.4,7.4,34.4,16.5Z",
    transform: "translate(0 -0.002)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListening);
export default __webpack_public_path__ + "static/media/ic_listening.268ad32f548b6a5c38bdaded1068a5fb.svg";
export { ForwardRef as ReactComponent };